import React from 'react';

const ParkIcon = () => (
    <svg className="map-icon map-icon-park" viewBox="0 0 48 48">
        <path
            className="map-icon-stroke-outter"
            d="M16.84,7.11H8.64A2.94,2.94,0,0,0,5.69,10v27.5a2.94,2.94,0,0,0,2.95,2.92H38.92a2.94,2.94,0,0,0,2.95-2.89l0-3.58a2.88,2.88,0,0,0-.84-2.07A2.94,2.94,0,0,0,39,31h-.47C19.38,31,18.84,9.33,18.84,9.11a2,2,0,0,0-2-2Z"
        />
        <path
            className="map-icon-park-fill"
            d="M16.84,9.11H8.64a.93.93,0,0,0-.95.92v27.5a.93.93,0,0,0,.95.92H38.92a.93.93,0,0,0,.95-.91l0-3.58A.93.93,0,0,0,39,33h-.47C18.74,33,16.84,12.12,16.84,9.11Z"
        />
        <path
            className="map-icon-stroke-inner"
            d="M15.9,10.11C16.28,14.76,19,34,38.48,34h.42l0,3.41H8.69V10.11H15.9m.94-1H8.64a.93.93,0,0,0-.95.92v27.5a.93.93,0,0,0,.95.92H38.92a.93.93,0,0,0,.95-.91l0-3.58A.93.93,0,0,0,39,33h-.47C18.74,33,16.84,12.12,16.84,9.11Z"
        />
    </svg>
);

export default React.memo(ParkIcon);
